import { SelectableOption } from "../../Shared/Shared";
import { Spinner } from "../../Spinner/Spinner"

interface Props {
  value?: any
  item: SelectableOption
  itemSelected?(item: SelectableOption): void
}

export function SelectableOptionView(props: Props) {
  const { value, item, itemSelected } = props;

  const getContent = (item: SelectableOption) => {
    if (item.isDivider) { return <div className="DropdownDivider"><div className="DropdownDividerLine"></div></div> }
    if (item.isHeading) { return <div className="DropdownHeading">{item.label}</div> }
    if (item.isSpinner) { return <div className="SelectableOptionSpinner" style={{ textAlign: "center" }}><Spinner /></div> }

    return <button onClick={() => itemSelected && itemSelected(item)} className={(value === item.value) ? "selected" : ""}>{item.indent ? <div style={{ width: item.indent * 12 + "px" }} className="indentSpacer" /> : null}{item.label}</button>
  }

  return <div className="SelectableOption" style={{ height: item.isDivider ? "16px" : "32px" }}>
    {getContent(item)}
  </div>
}

